/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 */

export const SET_IS_NAVBAR_EXPANDED = '@@nzr/currentSearch/SET_IS_NAVBAR_EXPANDED'
export const SET_SHORT_TERM_CALENDAR_OPEN = '@@nzr/filters/SET_SHORT_TERM_CALENDAR'
/* SEARCH UI */
export const UPDATE_SEARCH_UI = 'UPDATE_SEARCH_UI'
// Navbar
export const SET_MOBILE_VIEW_TYPE = '@@nzr/navbar/SET_MOBILE_VIEW_TYPE'

// saved Search
export const SEARCH_VIEW_TYPE = {
  FAVORITES: 'favorites',
  MAIN: 'main',
  MESSAGED: 'messaged',
  SAVE_SEARCH_CREATE: 'save_search_create',
  SEARCHES: 'searches',
}

export const API_RESPONSE = {
  // api error response
  OTHER_USER: 'may not create searches with email of other user',
}

export const NEARBY_SEARCH = 'nearby'

export const NAVBAR_MOBILE_LIST = 'list'

// Current Search View
export const SET_FREEZE_BOX = '@@nzr/CurrentSearchView/SET_FREEZE_BOX'
